<template lang="html">
    <section class="events">
        <div class="Vlt-grid">
            <div class="Vlt-col Vlt-col--A-1of4">
                <h3>To get your copy of:</h3>
                <img :src="png" style="height:auto;width:400px" alt="logo" />
            </div>
            <div class="Vlt-col Vlt-col--A-3of4">
                <div class="Vlt-card" style="height:380px">
                    <vlt-field label="First Name :">
                        <vlt-input id="firstname" v-model="firstname" :val="firstname" />
                    </vlt-field>
                    <vlt-field label="Last Name :">
                        <vlt-input id="lastname" v-model="lastname" :val="lastname" />
                    </vlt-field>
                    <vlt-field label="Company :">
                        <vlt-input id="lastname" v-model="company" :val="company" />
                    </vlt-field>
                    <vlt-field :label="t('Number to send information to')">
                        <vue-phone-number-input :translations="lang ? lang.phonetranslation : null" color="#131415"
                            :no-validator-state=true :default-country-code="nexmo.region" v-model="prettyNumber"
                            @update="onUpdate" />
                    </vlt-field>
                </div>
                <div class="Vlt-grid">
                    <div class="Vlt-col Vlt-col--A-1of3">
                        <qrcode style="display: inline-block" :value="qrtext" :options="{ width: 250 }"></qrcode>
                        <h5 style="margin-top:-10px;">Scan this code to send information through WhatsApp</h5>
                    </div>
                    <div class="Vlt-col Vlt-col--A-1of3">
                        <h5 style="display: inline-block;margin-right:20px;">- OR -</h5>
                        <vlt-button :label="t('Send through WhatsApp')" quaternary app @click="sendText(0)"
                            :disabled="(!isValid)" />
                    </div>
                    <div class="Vlt-col Vlt-col--A-1of3">
                        <h5 style="display: inline-block;margin-right:20px;">- OR -</h5>
                        <vlt-button :label="t('Send through SMS')" quaternary app @click="sendText(1)"
                            :disabled="(!isValid)" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="js">
import {
    parsePhoneNumberFromString
} from 'libphonenumber-js';
import {
    $NODEBASE
} from '@/base';
import {
    $HTTPDEMO,
    requestHandler
} from '@/services/nidsService.js';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import axios from 'axios';
import {
    VltIcon,
    VltButton,
    VltCard,
    VltTab,
    VltGrid,
    VltCol,
    VltField,
    VltInput,
    VltCallout,
    VltModal,
} from "@vonagevolta/vue";
export default {
    name: 'events',
    components: {
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
        "vlt-field": VltField,
        "vlt-input": VltInput,
        "vlt-callout": VltCallout,
        "vlt-modal": VltModal,
        qrcode: VueQrcode,
    },
    props: {
        nexmo: {
            type: Object,
            required: false
        },
        demoItem: {
            type: Object,
            required: false
        },
        baseLang: {
            type: Object,
            required: false
        },
        lang: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            postscript: "events",
            iHeight: 650,
            links: false,
            prettyNumber: '',
            numberStuff: {},
            number: '',
            isValid: false,
            qrtext: '',
            firstname: '',
            lastname: '',
            company: '',
            png: "https://vids.vonage.com/pages/events/omni.png",
        }
    },
    methods: {
        disp(key) {
            return key;
        },
        async sendText(why) {
            console.log("To " + this.number + " we send over " + why);
            let obj = {
                to: this.number,
                firstname: this.firstname,
                lastname: this.lastname,
                company: this.company,
                type: why ? 'sms' : 'wa',
                path: 'button',
            }
            let res = await this.NODEDEMO.post('/send', obj);
        },
        onUpdate(payload) {
            let numberStuff = payload;
            this.isValid = payload.isValid;
            if (payload.isValid) {
                this.number = numberStuff.formattedNumber.replace(/\D/g, '');
            } else {
                var test = parsePhoneNumberFromString(payload.formattedNumber);
                console.log("Re-checked number: ", test)
                if (test.isValid()) {
                    this.isValid = true;
                    this.number = test.number.replace(/\D/g, '');
                    console.log("new this.number = ", this.number)
                } else {
                    this.isValid = false;
                }
            }
        },
        t(key) { // T for Translate...
            return this.$tr(key, this.lang, this.baseLang)
        },
    },
    async created() {
        console.log("Created demo nexmo object: ", this.nexmo);
        this.number = this.nexmo['phone'];
        this.prettyNumber = ''; //parsePhoneNumberFromString("+" + this.nexmo['phone']).formatNational();
        this.qrtext = 'https://wa.me/447520645311?text=' + encodeURI('DOCREQUEST : Please send me the requested document.');
        var ps = "/" + this.postscript;
        if ($NODEBASE.indexOf("ngrok") > 0) {
            ps = "";
        }
        let nodeurl = $NODEBASE + ps;
        this.NODEDEMO = axios.create({
            baseURL: nodeurl,
            headers: {
                "Content-Type": "application/json",
            },
        });
        this.NODEDEMO.interceptors.request.use(
            request => requestHandler(request)
        );
        let res = await this.NODEDEMO.post('/register');
        console.log("Registration results: ", res)
        if (res.data.png) {
            this.png = res.data.png;
        }
    },
}
</script>

<style scoped lang="scss"></style>
